import {
  Directive,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[sdCopyToClipBoard]',
  standalone: true
})
export class SdCopyToClipboardDirective {
  constructor(
    el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      el.nativeElement.style.cursor = 'pointer';
    }
  }

  @Input()
  public displayAlert = false;

  @Input()
  public copyClipboard: string;

  @Input()
  public context: string;

  @Output()
  public copied: EventEmitter<string> = new EventEmitter<string>();

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    if (isPlatformBrowser(this.platformId)) {
      event.preventDefault();
      let copiedText;

      if (!this.copyClipboard) {
        copiedText = (event.target as HTMLElement).innerHTML.toLowerCase();
      } else {
        copiedText = this.copyClipboard;
      }
      const listener = (e: ClipboardEvent) => {

        const clipboard = e.clipboardData || window['clipboardData'];
        clipboard.setData('text', copiedText);
        e.preventDefault();
        this.copied.emit(copiedText);
        if (this.displayAlert) {
          alert(copiedText + ' has been copied to clipboard!');
        }
      };

      document.addEventListener('copy', listener, false);
      document.execCommand('copy');
      document.removeEventListener('copy', listener, false);
    }
  }
}
